module.exports = __webpack_public_path__ + "static/media/ZZZZPackedAsset-1.0_Normal.a606e817.png";